
export default {


	h1: {
		fontSize: '36px',
		lineHeight: '36px',
		padding:'10px 0',
		borderBottom: '1px solid #fff',
		marginBottom: 0,
	},
	h3:  {
		marginTop: '4px',
	},

	p:  {
		marginTop: '4px',
		
	},

	container : {
		fontFamily: 'Menlo-Regular, Menlo, monospace',
		fontSize: '14px',
		lineHeight: '22px',
		color: 'white',
		backgroundColor:'#E9EBEB',
		display: 'flex',
		flexFlow: 'column',
		flexDirection: 'column',
		height: '100vh',
	},

	flex : {
		position: 'relative',
		display: 'flex',
		height: '100vh',
		alignItems: 'center', 
		justifyContent: 'center',
		overflow: 'hidden',
	},

	flexEmpty : {
		display: 'flex',
		height: '100vh',
		flexWrap: 'wrap',
		justifyContent: 'center',
		alignItems: 'center',
	},

	portrait : {
		display: 'inline-block',
		backgroundColor: '#333',
		margin: '0 20px',
		width: '25%',
		height: 'auto',
	},
	portrait_img : {
		width: '100%',
	},
	portrait_p : {
		padding: '0px 10px',
	},

	textComponent: {
		width: '90%',
		backgroundColor: '#788383',
		
	},
	textComponentInner: {
		padding: '20px',
	},

	workshopItem: {
		flexGrow: 1,
		alignItems: 'stretch',
		backgroundColor: '#99ff00',
		height: '100%',
		backgroundSize: `cover`,

	}

}
	



// WEBPACK FOOTER //
// ./src/components/styles.js